import { APP_FEATURE_BASE_OBJECT } from "../feature-class";

export const REST_FEATURE_OBJECT = {
  ...APP_FEATURE_BASE_OBJECT,
  apiParam: 'rest',
}
